"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSendMessage;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSendMessage() {
  return (0, _useWebChatAPIContext.default)().sendMessage;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTZW5kTWVzc2FnZSIsInVzZVdlYkNoYXRBUElDb250ZXh0Iiwic2VuZE1lc3NhZ2UiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTZW5kTWVzc2FnZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVNlbmRNZXNzYWdlKCk6IChcbiAgdGV4dDogc3RyaW5nLFxuICBtZXRob2Q/OiBzdHJpbmcsXG4gIHsgY2hhbm5lbERhdGEgfT86IHsgY2hhbm5lbERhdGE/OiBhbnkgfVxuKSA9PiB2b2lkIHtcbiAgcmV0dXJuIHVzZVdlYkNoYXRBUElDb250ZXh0KCkuc2VuZE1lc3NhZ2U7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVlLFNBQVNBLGNBQVQsR0FJTDtFQUNSLE9BQU8sSUFBQUMsNkJBQUEsSUFBdUJDLFdBQTlCO0FBQ0QifQ==